import { MenuToggle } from './elements/menu-toggle'
import { smoothScrollCreate, smoothScrollKill } from './scroll-smoother'

const $html = $('html')
const menuToggle = new MenuToggle('.menu-toggle')

function menuOpenAnimations() {

  smoothScrollKill()

  $html.addClass('modal-visible')

  $('.mobile-menu-modal').addClass('is-open')
}

function menuCloseAnimations() {

  smoothScrollCreate()

  $html.removeClass('modal-visible')

  $('.mobile-menu-modal').removeClass('is-open')
}
document.addEventListener("toggleMenu", function(e) {
  if(e.detail && e.detail.showMenu) {
    menuOpenAnimations()
  } else {
    menuCloseAnimations()
  }
})



//-- Show Hide on Scroll ---
let doc = document.documentElement
let w = window
let vH = window.innerHeight

let prevScroll = w.scrollY || doc.scrollTop
let curScroll
let direction = 0
let prevDirection = 0

let header = document.querySelector('header')

let checkScroll = function () {
  if (curScroll > prevScroll && curScroll > 200) {
    //scrolled up
    direction = 2
  } else if (curScroll < prevScroll) {
    //scrolled down
    direction = 1
  }

  if (direction !== prevDirection) {
    if (direction === 2) {
      header.classList.add('is-hidden')
    } else {
      header.classList.remove('is-hidden')
    }
    prevDirection = direction
  }

  if (curScroll > 400) {
    header.classList.add('scrolled-down')
  } else {
    header.classList.remove('scrolled-down')
  }

  prevScroll = curScroll
}


//detect scroll and checkScroll
window.addEventListener('scroll', function(){
  curScroll = w.scrollY || doc.scrollTop
  checkScroll()
})
